import classNames from "classnames";
import { motion } from "framer-motion";
import { RefObject } from "react";
import { GameRound } from "shared/games/types/GameRound";
import useOnChangeHandler from "../../../molecules/GameRoundBuilders/useOnChangeHandler";
import * as a from "../animationConsts";
import TechniqueShape from "../../../molecules/GameRoundBuilders/TechniqueShape";
import { AllTechniqueGameDescriptions } from "shared/games/allTechniqueGameDescriptions";
import { Technique } from "shared/games/technique";

interface Props {
  basicRef: RefObject<HTMLDivElement>;
  techniquesAndGames: AllTechniqueGameDescriptions;
  changers: ReturnType<typeof useOnChangeHandler>;
  value: GameRound;
}

export default function BasicOptionsScreen({
  basicRef,
  changers,
  value,
  techniquesAndGames,
}: Props) {
  return (
    <div
      ref={basicRef}
      className={classNames(
        "grid grid-cols-[repeat(auto-fit,minmax(80px,1fr))] gap-10 lg:grid-cols-4 px-5 md:px-10 py-5 rounded border-2 border-white"
      )}
    >
      {Object.values(techniquesAndGames).map((technique, index) => {
        if (technique.technique === Technique.mixPuzzle) return null;

        return (
          <motion.div
            key={technique.technique}
            layoutId={technique.technique}
            layout="preserve-aspect"
            transition={{ duration: 0.3, delay: (index - 1) * 0.05 }}
            initial={{
              opacity: index === 0 ? 1 : a.initial.opacity,
              y: index === 0 ? "auto" : a.initial.y,
            }}
            exit={a.exit}
            animate={a.animate}
          >
            <TechniqueShape
              changers={changers}
              technique={technique}
              value={value}
            />
          </motion.div>
        );
      })}
    </div>
  );
}
